import { IIntegration } from "./queries/listIntegrations";

export const getIntegrationById = ({
  id,
  integrationsList,
}: {
  id: string;
  integrationsList: IIntegration[];
}) => integrationsList.find((integration) => integration.id === id);
